var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    viewBox: "0 0 261 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 195.588C0 197.797 1.79086 199.588 4 199.588H257C259.209 199.588 261 197.797 261 195.588V3.99999C261 1.79085 259.209 0 257 0H4C1.79086 0 0 1.79086 0 4V195.588ZM16.5671 21.5338C15.7959 20.865 15.3529 19.8945 15.3529 18.8738V18.8738C15.3529 16.9292 16.9293 15.3528 18.8739 15.3528H242.126C244.071 15.3528 245.647 16.9291 245.647 18.8737V18.8737C245.647 19.8944 245.204 20.8649 244.433 21.5337L133.121 118.064C131.617 119.368 129.383 119.368 127.879 118.064L16.5671 21.5338ZM239.027 46.5496C241.617 44.3035 245.647 46.1433 245.647 49.5715V158.616C245.647 162.397 240.886 164.067 238.524 161.115L200.411 113.476C199.032 111.753 196.518 111.472 194.792 112.849L189.039 117.439C187.311 118.818 187.029 121.338 188.411 123.064L232.143 177.737C234.238 180.356 232.373 184.235 229.019 184.235H31.9807C28.6268 184.235 26.7621 180.356 28.8571 177.737L72.5896 123.064C73.9707 121.338 73.6891 118.818 71.9609 117.439L66.2078 112.849C64.4826 111.472 61.9684 111.753 60.5895 113.476L22.4763 161.115C20.1142 164.067 15.3529 162.397 15.3529 158.616V49.5715C15.3529 46.1433 19.3835 44.3035 21.9736 46.5496L127.879 138.391C129.383 139.695 131.617 139.695 133.121 138.391L239.027 46.5496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.663ce1b6aab3c46f75972c184d085b60.svg";
export { ForwardRef as ReactComponent };